// extracted by mini-css-extract-plugin
export default {"CreateProviderModalDialog":"CreateProviderModalDialog_CreateProviderModalDialog__c-Sa2"};